import { render, staticRenderFns } from "./LandingPageNew.vue?vue&type=template&id=43b40598&scoped=true&"
import script from "./LandingPageNew.vue?vue&type=script&lang=js&"
export * from "./LandingPageNew.vue?vue&type=script&lang=js&"
import style0 from "./LandingPageNew.vue?vue&type=style&index=0&id=43b40598&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43b40598",
  null
  
)

export default component.exports